import React, { useEffect, useState } from 'react';
import { createClient } from '@supabase/supabase-js';

// Cấu hình từ thông tin Giai đoạn 1
const supabase = createClient('https://mveaalhzvxulhzujaicw.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im12ZWFhbGh6dnh1bGh6dWphaWN3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk1MjQ1MTIsImV4cCI6MjA4NTEwMDUxMn0.J5S7jD0qe_a8o0IEONVnTF6mb6nltOomu5llx0Tgld0');

const LeaderboardPage = () => {
    const [users, setUsers] = useState([]);
    const [page, setPage] = useState(0);
    const pageSize = 20;

    useEffect(() => {
        fetchLeaderboard();
    }, [page]);

    const fetchLeaderboard = async () => {
        const { data, error } = await supabase
            .from('leaderboard')
            .select('*')
            .order('total_stars', { ascending: false })
            .range(page * pageSize, (page + 1) * pageSize - 1);

        if (data) setUsers(data);
    };

    return (
        <div className="leaderboard-admin">
            <h2>Bảng xếp hạng người chơi (Top 100)</h2>
            <table border="1" cellPadding="10" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr style={{ backgroundColor: '#f4f4f4' }}>
                        <th>Hạng</th>
                        <th>Tên người chơi</th>
                        <th>Số sao ⭐️</th>
                        <th>Cập nhật cuối</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map((user, index) => (
                        <tr key={user.id}>
                            <td>{(page * pageSize) + index + 1}</td>
                            <td>{user.display_name}</td>
                            <td>{user.total_stars}</td>
                            <td>{new Date(user.updated_at).toLocaleString()}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div style={{ marginTop: '20px', textAlign: 'center' }}>
                <button onClick={() => setPage(p => Math.max(0, p - 1))}>Trang trước</button>
                <span style={{ margin: '0 15px' }}>Trang {page + 1}</span>
                <button onClick={() => setPage(p => p + 1)}>Trang sau</button>
            </div>
        </div>
    );
};

export default LeaderboardPage;